import { useNavigate } from "react-router";
import { UserProfile } from "../CompanyTypes";
import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { Login, RegisterUser } from "../Services/AuthService";
import { toast } from "react-toastify";

type UserContextType = {
  user: UserProfile | null;
  token: string | null;
  loginUser: (username: string, password: string, from: string) => void;
  registerUser: (email: string, username: string, password: string) => void;
  isLoggedIn: () => boolean;
  logoutUser: () => void;
  isLoading: boolean;
};
type Props = { children: React.ReactNode };
const AuthContext = createContext<UserContextType>({} as UserContextType);

export const AuthProvider = ({ children }: Props) => {
  const navigate = useNavigate();
  const [token, setToken] = useState<string | null>(null);
  const [user, setUser] = useState<UserProfile | null>(null);
  const [isReady, setIsReady] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  useEffect(() => {
    const user = localStorage.getItem("user");
    const token = localStorage.getItem("token");
    if (user && token) {
      setUser(JSON.parse(user));
      setToken(token);
      axios.defaults.headers.common["Authorization"] = "Bearer" + token;
    }
    setIsReady(true);
  }, []);

  const loginUser = async (
    username: string,
    password: string,
    from: string
  ) => {
    try {
      setIsLoading(true);
      const res = await Login(username, password);
      if (res) {
        localStorage.setItem("token", res?.data.token);

        const userObj = {
          username: res?.data.userName,
          email: res?.data.email,
        };
        localStorage.setItem("user", JSON.stringify(userObj));
        setUser(userObj!);
        setToken(res?.data.token!);
        navigate(from, { replace: true });
        toast.success("login Sucess");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const registerUser = async (
    email: string,
    username: string,
    password: string
  ) => {
    try {
      setIsLoading(true);
      const res = await RegisterUser(email, username, password);
      if (res) {
        localStorage.setItem("token", res?.data.token);
        const regUser = {
          email: res?.data.email,
          username: res?.data.userName,
        };
        localStorage.setItem("user", JSON.stringify(regUser));
        setToken(res?.data.token!);
        setUser(regUser!);
        navigate("/search");
        toast.success("Registeration Success");
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };
  const isLoggedIn = () => {
    return !!user;
  };
  const logoutUser = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    setToken("");
    axios.defaults.headers.common["Authorization"] = "";
  };
  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        registerUser,
        loginUser,
        isLoggedIn,
        logoutUser,
        isLoading,
      }}
    >
      {isReady ? children : null}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
